import styled from 'styled-components';
import {
  desktop_breakpoint,
  desktop_breakpoint_extended,
} from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';

export const SearchPostsStyles = styled.div`
  display: flex;
  min-width: 50px;
  align-items: center;

  .search-icon {
    min-width: 50px;
    button {
      cursor: pointer;

      background-color: transparent;
      border: 0;
      width: 100%;
      height: 55px;

      background: no-repeat url(${(props) => props.searchImage});
      background-position: top 50% left 2px;
      background-size: 25px 25px;
      cursor: pointer;
    }
  }

  .topic-search {
    min-width: 150px;
    .suggestion-box {
      /* Note: on iOS devices, the input element will zoom in if the font size is less than 16px and the zoom cuts off the search results. */
      /* To strike a balance, I chose to leave the placeholder text 10px and make the input text 16px when typing so it won't zoom. */
      .dropdown-textbox {
        input {
          background-color: transparent;
          border: 0;
          font-size: 16px;
          letter-spacing: 0.5px;

          &::placeholder {
            font-size: 10px;
            letter-spacing: 0.5px;
          }
        }
      }

      svg {
        display: none;
      }
    }
    .suggestion-box.open {
      .dropdown-menu {
        width: 80vw;
        left: -35px;
      }
      li {
        font-size: 10px;
        white-space: normal;
        /* design team asked for additional padding top on first and bottom on last item to make space between items match middle items */
        :first-child {
          padding: 15px 10px 10px;
        }
        :last-child {
          padding: 10px 10px 15px;
        }
      }
    }
  }

  @media only screen and (min-width: ${desktop_breakpoint}px) {
    .search-icon,
    .topic-search {
      max-width: 200px;
    }

    .topic-search {
      .suggestion-box.open {
        .dropdown-menu {
          width: 340px;
        }
      }
    }
  }

  @media screen and (min-width: ${desktop_breakpoint_extended}px) {
    .search-icon,
    .topic-search {
      max-width: 300px;
    }
  }
`;
